module.exports = __webpack_public_path__ + "static/img/nav_sjjq.3de6f62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_sjjq.svg
// module id = JqFP
// module chunks = 1